import ArrowIcon from "@assets/icons/arrow-left.svg";
import styled from "@emotion/styled";
import { row } from "@ui/style";
import { colors } from "@ui/style/colors";
import React from "react";

interface BackButtonProps {
	onClick: () => void;
}

export const BackButton = ({ onClick }: BackButtonProps): JSX.Element => (
	<Button onClick={onClick}>
		<ArrowIcon height={24} width={24} color={colors.grey} />
	</Button>
);

const Button = styled.button`
	cursor: pointer;
	border: 1px solid ${() => colors.primary25};
	border-radius: 8px;
	padding: 8px 16px;
	background-color: ${colors.white};
	${row(undefined, "center", "center")};

	:hover {
		border: 1px solid ${() => colors.primary};
	}
`;
